import type { MetadataItem } from '@/graphql/saleor/api';
import type { Maybe } from '@/lib/types';

export const getMetaValue = (metadata: readonly MetadataItem[], key: string) =>
  metadata?.find((meta) => meta.key === key)?.value;

export const parseComplexMetadata = <T>(value: Maybe<string>): T | null => {
  try {
    return JSON.parse(value!).payload;
  } catch {
    return null;
  }
};

export const sanitizeMetadata = <T extends { __typename?: string }>(
  metadata: readonly T[] | T[] | null | undefined,
): Omit<T, '__typename'>[] =>
  (metadata ?? []).map(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ({ __typename, ...rest }) => rest as Omit<T, '__typename'>,
  );
